import axios from 'axios'
import {AuthModel, UserModel} from './_models'
import {getAxiosConfig} from './AuthHelpers'

const API_URL = process.env.REACT_APP_API_URL

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/auth/token`
export const LOGIN_URL = `${API_URL}/auth/login`
export const REGISTER_URL = `${API_URL}/verification/account?user=`
export const REQUEST_PASSWORD_URL = `${API_URL}/recuperacion_contrasenia`
export const RESET_PASSWORD_URL = `${API_URL}/recuperacion_contrasenia/cambiar_contrasenia`
export const VALIDATE_RESET_PASSWORD_LINK_URL = `${API_URL}/recuperacion_contrasenia/validar`

// Server should return AuthModel
export function login(email: string, password: string) {
  return axios.post<AuthModel>(LOGIN_URL, {
    email,
    password,
  })
}

// Server should return AuthModel
export function register(newPassword: string, confirmationPassword: string, user_id?: string) {
  return axios.post(`${REGISTER_URL}${user_id}`, {
    newPassword,
    confirmationPassword,
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(correo: string) {
  return axios.post<{result: boolean}>(REQUEST_PASSWORD_URL, {
    correo,
  })
}

export function resetPassword(usuarioId: string, password: string) {
  return axios.put<{result: boolean}>(RESET_PASSWORD_URL, {
    usuarioId,
    password,
  })
}

export const validateResetPasswordLink = async (
  usuarioId: string,
  correo: string
): Promise<boolean> => {
  try {
    const response = await axios.post(VALIDATE_RESET_PASSWORD_LINK_URL, {usuarioId, correo})
    const responseData = response.data
    return responseData.msg === 'Los datos son correctos'
  } catch (error) {
    console.error('Error validating reset password link:', error)
    return false
  }
}

export function getUserByToken(token: string) {
  return axios.post<UserModel>(
    GET_USER_BY_ACCESSTOKEN_URL,
    {
      token: token,
    },
    getAxiosConfig()
  )
}
